import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import BaseNode from './BaseNode';

// Detect if content looks like markdown worth rendering
function hasMarkdown(text = '') {
  return (
    /^#{1,6}\s/m.test(text) ||         // headings
    /\*\*[^*]+\*\*/m.test(text) ||     // bold
    /^\s*[-*]\s/m.test(text) ||        // bullet lists
    /^\s*\d+\.\s/m.test(text) ||       // numbered lists
    /^\|.+\|/m.test(text) ||           // tables
    /```[\s\S]*?```/m.test(text)       // code blocks
  );
}

const TextNode = ({ data, onChange, onSubmit }) => {
  const changeHandler = onChange || data.onChange || (() => {});

  const handleChange = (e) => {
    const updatedContent = e.target.value;
    changeHandler({ ...data, content: updatedContent });
  };

  const content = data.content || '';
  const renderMarkdown = !data.isInput && hasMarkdown(content);

  return (
    <BaseNode data={data} onChange={changeHandler} onSubmit={onSubmit} nodeType="textNode">
      <div
        className="text-node"
        onMouseDown={(e) => e.stopPropagation()}
        onWheel={(e) => e.stopPropagation()}
      >
        {data.isInput ? (
          <textarea
            className="text-node-textarea"
            value={content}
            onChange={handleChange}
            placeholder={data.placeholder}
            onMouseDown={(e) => e.stopPropagation()}
            onWheel={(e) => e.stopPropagation()}
          />
        ) : renderMarkdown ? (
          <div className="text-node-markdown">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {content}
            </ReactMarkdown>
          </div>
        ) : (
          content
        )}
      </div>
    </BaseNode>
  );
};

export default memo(TextNode);
